import i18n from '../i18n'
import VueI18n from 'vue-i18n'

export * from './unit-filter'

export function translate(key: VueI18n.Path, values?: VueI18n.Values): string {
    return i18n.t(key, values) as string
}

export function defaultValue(value: any) {
    if (!value) {
        return value === 0 ? value : '--'
    }
    return value
}
